import { render } from "./admin-register-maintenance.vue?vue&type=template&id=51ae891a&scoped=true"
import script from "./admin-register-maintenance.vue?vue&type=script&lang=js"
export * from "./admin-register-maintenance.vue?vue&type=script&lang=js"

import "./admin-register-maintenance.vue?vue&type=style&index=0&id=51ae891a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51ae891a"],['__file',"src/components/applications/admin/admin-register-maintenance.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "51ae891a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('51ae891a', __exports__)) {
    api.reload('51ae891a', __exports__)
  }
  
  module.hot.accept("./admin-register-maintenance.vue?vue&type=template&id=51ae891a&scoped=true", () => {
    api.rerender('51ae891a', render)
  })

}


export default __exports__